<app-dialog>
  <div class="scroll-wrapper" body>
    <app-full-loading
      *ngIf="tasksService.loading"
      [backdrop]="true"
    ></app-full-loading>

    <form [formGroup]="taskForm">
      <div *ngIf="f['transforFromObjID'].value">
        <span class="task-input-label">{{
          "FORM.LABEL.TRANSFORM_FROM" | translate
        }}</span>
        <span>{{ f["transforFromObjID"].value }}</span>
      </div>
      <div class="input-row">
        <div class="input-form">
          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>{{ "FORM.LABEL.SUBJECT" | translate }}</mat-label>
            <input
              matInput
              #subjectInput
              [placeholder]="'FORM.PLACEHOLDER.TASK_SUBJECT' | translate"
              formControlName="cmTaskSubject"
              maxlength="300"
            />
            <mat-hint align="end"
              >{{ subjectInput.value.length }} / 300</mat-hint
            >
            <mat-error>
              <span *ngIf="f['cmTaskSubject'].errors?.['required']">
                {{ "FORM.ERROR.FIELD_REQUIRED" | translate }}
              </span>
            </mat-error>
          </mat-form-field>
        </div>

        <div class="input-form">
          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>{{ "FORM.LABEL.PRIORITY" | translate }}</mat-label>

            <mat-select formControlName="myCMTaskPriority">
              <mat-option
                [value]="option.value"
                *ngFor="let option of tasksService.taskPriority"
                class="menu-panel-dark"
              >
                <span class="option-icon-item">
                  <svg-icon
                    name="arrow-circle"
                    class="status-icon"
                    [ngClass]="'status-icon-' + option.value"
                  ></svg-icon>

                  {{ option.label }}
                </span>
              </mat-option>
            </mat-select>

            <svg-icon
              name="arrow-circle"
              class="status-icon"
              [ngClass]="'status-icon-' + f['myCMTaskPriority'].value"
              matPrefix
            ></svg-icon>
          </mat-form-field>
        </div>
      </div>

      <div class="input-form">
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>{{ "FORM.LABEL.OWNER" | translate }}</mat-label>

          <mat-select
            formControlName="ownerID"
            [placeholder]="'FORM.PLACEHOLDER.UNSELECTED' | translate"
          >
            <mat-option [value]="null" class="menu-panel-dark">
              <span class="option-icon-item">
                {{ "FORM.PLACEHOLDER.UNSELECTED" | translate }}
              </span>
            </mat-option>

            <mat-option
              [value]="user.userId"
              *ngFor="let user of usersByTenantId"
              class="menu-panel-dark"
            >
              <span class="option-icon-item">
                {{ user.name }}
              </span>
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div
        class="input-row"
        *ngIf="action !== 'create' && f['dateTimeCreated'].value"
      >
        <div class="input-form">
          <mat-form-field
            appearance="outline"
            floatLabel="always"
            (click)="dateCreated.open()"
          >
            <mat-label>{{ "FORM.LABEL.DATE_CREATED" | translate }}</mat-label>
            <input
              matInput
              [placeholder]="'FORM.PLACEHOLDER.PICK_DATE' | translate"
              formControlName="dateTimeCreated"
              [matDatepicker]="dateCreated"
              [disabled]="true"
            />
            <mat-datepicker-toggle
              matIconSuffix
              [for]="dateCreated"
            ></mat-datepicker-toggle>
            <mat-datepicker #dateCreated [disabled]="true"></mat-datepicker>
          </mat-form-field>
        </div>
      </div>

      <div class="input-form">
        <mat-form-field
          appearance="outline"
          [ngClass]="'select-status-' + f['myCMTaskStatus'].value"
        >
          <mat-label>{{ "FORM.LABEL.STATUS" | translate }}</mat-label>
          <mat-select formControlName="myCMTaskStatus">
            <mat-option
              [value]="option.value"
              *ngFor="let option of allStatuses"
              [disabled]="option.value === 0 || option.value === 1"
              class="menu-panel-dark"
            >
              {{ option.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <!-- schedule -->
      <div class="input-form">
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>{{ "FORM.LABEL.SCHEDULING_TASK" | translate }}</mat-label>
          <mat-select formControlName="scheduleType">
            <mat-option
              *ngFor="let option of schedulingType"
              [value]="option.value"
              class="menu-panel-dark"
            >
              {{ option.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="input-row" *ngIf="f['scheduleType'].value === 'dueDate'">
        <div class="input-form">
          <mat-form-field
            appearance="outline"
            floatLabel="always"
            (click)="picker.open()"
          >
            <mat-label>{{ "FORM.LABEL.DUE_DATE" | translate }}</mat-label>
            <input
              matInput
              [placeholder]="'FORM.PLACEHOLDER.PICK_DATE' | translate"
              formControlName="dateTimeSLA"
              [matDatepicker]="picker"
              [min]="todayDate"
            />
            <mat-datepicker-toggle
              matIconSuffix
              [for]="picker"
            ></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        </div>
      </div>

      <div
        class="task-reccurence"
        *ngIf="f['scheduleType'].value === 'recurrence'"
        class="toogle-button"
      >
        <form [formGroup]="recurrenceForm" class="reccurence-form">
          <div class="input-row">
            <div class="input-form">
              <mat-form-field
                appearance="outline"
                floatLabel="always"
                (click)="StartDateTime.open()"
              >
                <mat-label>{{
                  "FORM.LABEL.START_DATE_TIME" | translate
                }}</mat-label>
                <input
                  matInput
                  [placeholder]="'FORM.PLACEHOLDER.START_DATE_TIME' | translate"
                  formControlName="StartDateTime"
                  [matDatepicker]="StartDateTime"
                  [min]="todayDate"
                />
                <mat-datepicker-toggle
                  matIconSuffix
                  [for]="StartDateTime"
                ></mat-datepicker-toggle>
                <mat-datepicker #StartDateTime></mat-datepicker>
              </mat-form-field>
            </div>
            <div class="input-form">
              <mat-form-field appearance="outline" floatLabel="always">
                <mat-label>{{ "FORM.LABEL.TIME" | translate }}</mat-label>
                <input
                  matInput
                  type="time"
                  min="00:00"
                  max="12:00"
                  [placeholder]="'HH:MM AM'"
                  formControlName="StartTime"
                />
                <div matSuffix>
                  <mat-button-toggle-group formControlName="StartTimeFormat">
                    <mat-button-toggle
                      *ngFor="let item of timeFormats"
                      [value]="item.value"
                      >{{ item.label }}</mat-button-toggle
                    >
                  </mat-button-toggle-group>
                </div>
              </mat-form-field>
            </div>
          </div>
          <div class="input-row">
            <div class="input-form">
              <mat-form-field
                appearance="outline"
                floatLabel="always"
                (click)="EndDateTime.open()"
              >
                <mat-label>{{
                  "FORM.LABEL.END_DATE_TIME" | translate
                }}</mat-label>
                <input
                  matInput
                  [placeholder]="'FORM.PLACEHOLDER.END_DATE_TIME' | translate"
                  formControlName="EndDateTime"
                  [matDatepicker]="EndDateTime"
                  [min]="todayDate"
                />
                <mat-datepicker-toggle
                  matIconSuffix
                  [for]="EndDateTime"
                ></mat-datepicker-toggle>
                <mat-datepicker #EndDateTime></mat-datepicker>
              </mat-form-field>
            </div>
            <div class="input-form">
              <mat-form-field appearance="outline" floatLabel="always">
                <mat-label>{{ "FORM.LABEL.TIME" | translate }}</mat-label>
                <input
                  type="time"
                  min="00:00"
                  max="12:00"
                  matInput
                  [placeholder]="'HH:MM AM'"
                  formControlName="EndTime"
                />
                <div matSuffix>
                  <mat-button-toggle-group formControlName="EndTimeFormat">
                    <mat-button-toggle
                      *ngFor="let item of timeFormats"
                      [value]="item.value"
                      >{{ item.label }}</mat-button-toggle
                    >
                  </mat-button-toggle-group>
                </div>
              </mat-form-field>
            </div>
          </div>
          <div>
            <mat-button-toggle-group formControlName="RecurrenceType">
              <mat-button-toggle
                *ngFor="let item of frequency"
                [value]="item.value"
                >{{ item.label }}</mat-button-toggle
              >
            </mat-button-toggle-group>
          </div>

          <div class="">
            <div class="task-input">
              Recur every
              <div class="input-form input-small">
                <mat-form-field appearance="outline">
                  <input matInput formControlName="Interval" />
                </mat-form-field>
              </div>
              {{ textOfRecurrenceType }}
            </div>
          </div>

          <div
            *ngIf="
              (r['Interval'].value === '1' &&
                r['RecurrenceType'].value === 'DailyRecurrence') ||
              r['RecurrenceType'].value === 'WeeklyRecurrence'
            "
          >
            <mat-button-toggle-group
              formControlName="DaysOfWeek"
              multiple="true"
            >
              <mat-button-toggle
                *ngFor="let item of weekDays"
                [value]="item.value"
                >{{ item.label }}</mat-button-toggle
              >
            </mat-button-toggle-group>
            <mat-error *ngIf="r['DaysOfWeek']?.errors?.['required']">{{
              "FORM.ERROR.FIELD_REQUIRED" | translate
            }}</mat-error>
          </div>

          <div *ngIf="r['RecurrenceType'].value === 'MonthlyRecurrence'">
            <span class="task-input-label">{{
              "FORM.LABEL.DAYS" | translate
            }}</span>
            <div class="input-form input-small-m">
              <mat-form-field appearance="outline" floatLabel="always">
                <input matInput formControlName="DaysOfMonthIndex" />
              </mat-form-field>
            </div>
          </div>

          <div *ngIf="r['RecurrenceType'].value === 'YearlyRecurrence'">
            <span class="task-input-label">{{
              "FORM.LABEL.DAYS" | translate
            }}</span>
            <div class="input-form input-small-m">
              <mat-form-field appearance="outline" floatLabel="always">
                <input matInput formControlName="DaysOfYearIndex" />
              </mat-form-field>
            </div>
          </div>

          <div class="input-form">
            <mat-form-field appearance="outline" floatLabel="always">
              <mat-label>{{ "FORM.LABEL.TIME_ZONES" | translate }}</mat-label>
              <mat-select formControlName="TimeZoneName">
                <mat-option
                  *ngFor="let option of timeZones"
                  [value]="option.value"
                  class="menu-panel-dark"
                >
                  {{ option.label }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </form>
      </div>

      <div class="input-form">
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>{{ "FORM.LABEL.DESCRIPTION" | translate }}</mat-label>
          <textarea
            matInput
            #descInput
            [placeholder]="'FORM.PLACEHOLDER.DESCRIPTION' | translate"
            formControlName="cmTaskFullDescription"
            maxlength="300"
            rows="3"
          ></textarea>
          <mat-hint align="end">{{ descInput.value.length }} / 300</mat-hint>
        </mat-form-field>
      </div>

      <div class="input-form">
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>{{ "FORM.LABEL.TAGS" | translate }}</mat-label>
          <mat-chip-grid #tagsGrid formControlName="cmTags">
            <mat-chip-row
              *ngFor="let tag of f['cmTags'].value"
              (removed)="removeTag(tag)"
              [editable]="true"
              (edited)="editTag(tag, $event)"
            >
              {{ tag }}
              <button matChipRemove>
                <svg-icon name="cross" class="stroked"></svg-icon>
              </button>
            </mat-chip-row>
          </mat-chip-grid>
          <input
            matInput
            [placeholder]="'FORM.PLACEHOLDER.TAGS' | translate"
            [matChipInputFor]="tagsGrid"
            [matChipInputAddOnBlur]="true"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            maxlength="50"
            (matChipInputTokenEnd)="addTag($event)"
          />
          <mat-error>
            <span *ngIf="f['cmTags'].errors?.['maxlength']">
              {{ "FORM.ERROR.TAGS_MAX_LENGTH" | translate : { length: "20" } }}
            </span>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="commentaries-form">
        <app-commentaries
          [commentaries]="f['cmTaskComments'].value"
          [isShowCreateComment]="data.data"
          (onAdd)="addNewComment($event)"
        ></app-commentaries>
      </div>
    </form>
  </div>

  <ng-container actions>
    <button
      mat-flat-button
      *ngIf="data.cancelBtn"
      (click)="onCancel()"
      [disabled]="tasksService.loading"
    >
      {{ data.cancelBtn | translate | uppercase }}
    </button>

    <button
      mat-flat-button
      *ngIf="data.successBtn"
      color="primary"
      type="submit"
      [disabled]="tasksService.loading || mode === 'open'"
      (click)="onSubmit()"
    >
      {{ data.successBtn | translate | uppercase }}
    </button>
  </ng-container>
</app-dialog>
